import { Div, Label, Touchable } from "@grassrootly/rn-core";
import { GameInfoProps, GameTabsProps } from "./GamePreview.types";
import * as React from "react";
import { getGameMVP, isFinished } from "./lib";
import PreGameAttendees from "./game-attendees/PreGameAttendees";
import GameDetails from "./game-details/GameDetails";
import GamePlayers from "./game-attendees/GamePlayers";
import { DEFAULT_TEAMS, GameStatues } from "@grassrootly/api";
import GameMVP from "./game-mvp/GameMVP";

const TopBar = ({ route, onPress, isActive }: GameTabsProps) => (
  <Touchable
    classNames={[
      "flex1",
      "alignItemsCenter",
      "justifyContentCenter",
      "pv16",
      "bwBottom-{1}",
      isActive ? "borderPrimary" : "borderSecondary",
      "mb-{8}",
    ]}
    key={route.key}
    onPress={onPress}
  >
    <Label>{route.title}</Label>
  </Touchable>
);

export default function GameInfo({ game }: GameInfoProps) {
  const [index, setIndex] = React.useState(0);

  const { routes } = React.useMemo(() => {
    let r = { routes: [] as any[] };
    if (!isFinished(game) && game.status !== GameStatues.CONFIRMED) {
      r = {
        routes: [
          {
            key: "attendees",
            title: "ATTENDEES",
            renderComponent: () => <PreGameAttendees key={0} attendees={game.attendees} />,
          },
          { key: "details", title: "DETAILS", renderComponent: () => <GameDetails key={1} game={game} /> },
        ],
      };
    } else {
      r = {
        routes: [
          {
            key: "teamA",
            title: "Beli",
            renderComponent: () => (
              <GamePlayers
                key={0}
                attendees={game.attendees.filter((a) => a.team === DEFAULT_TEAMS.HOST)}
                showPoints={game.status === GameStatues.FINALIZED}
              />
            ),
          },
          {
            key: "teamB",
            title: "Markeri",
            renderComponent: () => (
              <GamePlayers
                key={1}
                attendees={game.attendees.filter((a) => a.team === DEFAULT_TEAMS.VISITOR)}
                showPoints={game.status === GameStatues.FINALIZED}
              />
            ),
          },
          /* {
            key: "players",
            title: "All Players",
            renderComponent: () => (
              <GamePlayers
                key={2}
                attendees={game.attendees}
                showTeam
                showPoints={game.status === GameStatues.FINALIZED}
              />
            ),
          }, */
        ],
      };
    }
    return r;
  }, [game, game.attendees]);

  return (
    <Div classNames={["mt-{16}", "flex1"]}>
      {game.status === GameStatues.FINALIZED && game.attendees.length ? (
        <GameMVP mvp={getGameMVP(game.attendees)} />
      ) : null}
      <Div classNames={["flexRow", "bgNeutralDarkerDark"]}>
        {routes.map((route, i) => (
          <TopBar key={route.key} route={route} onPress={() => setIndex(i)} isActive={i === index} />
        ))}
      </Div>
      {routes.map((route, i) => (i === index ? route.renderComponent() : null))}
    </Div>
  );
}
